module.exports = __webpack_public_path__ + "static/media/showfilter.7e300362.svg";